import { Provider } from '@angular/core';

import { SupplyChainApiService } from './supply-chain-api.service';
import { SupplyChainHttpService } from './supply-chain-http.service';

/** Registra la implementación de `SupplyChainApiService` que usa la app. */
export function provideSupplyChain(): Provider[] {
  return [{ provide: SupplyChainApiService, useClass: SupplyChainHttpService }];
}
